<h1 mat-dialog-title>Händler zuordnen</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-viehhaendler-zuordnen [dialog]="true" [tier]="tier" (saved)="dialogRef.close(tier)">
        <ng-container additional-actions>
            <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
        </ng-container>
    </kiene-gruppe-tier-viehhaendler-zuordnen>
</div>
